import React from 'react';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  id?: string;
  value: string;
  label?: string;
  errorMessage?: string;
  isRequired?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const Textarea: React.FC<TextareaProps> = ({
  name,
  id,
  value,
  label,
  errorMessage,
  isRequired,
  onChange,
  ...otherProps
}) => {
  return (
    <div className="mz-form-item mz-form-item--textarea">
      <textarea
        name={name}
        className='mz-form-item__textarea'
        id={id}
        value={value}
        required={isRequired}
        onChange={onChange}
        {...otherProps}
      />
      {label && (
        <label
          className={`mz-form-item__label ${value.length ? 'shrink' : ''}`}
          htmlFor={id}
        >
          {label}{(isRequired && label) && (<span className="mz-form-item__required-star">*</span>)}
        </label>
      )}
      {errorMessage && (
        <div className="mz-form-item__error-message">{errorMessage}</div>
      )}
    </div>
  );
};

export default Textarea;
